import { IScoreboardEvent } from "./scoreboard-models";
import { Module, MutationTree } from "vuex";
import type { IRootState } from "../../store/root-state";
import { ScoreboardService } from "./scoreboard-service";
import * as R from "ramda";
import { IScoreboardsEventQuery } from "./scoreboard-data";

// Import service locator functions
// import {
//   getScoreboardService,
// } from "../../common/services/service-registry";

export enum SCOREBOARD_STORE_CONST {
  SCOREBOARD_CONST_MODULE_NAME = "SCOREBOARD_CONST_MODULE_NAME",

  SCOREBOARD_MUTATIONS_SET_SCOREBOARD = "SCOREBOARD_MUTATIONS_SET_SCOREBOARD",
  SCOREBOARD_MUTATIONS_SET_SCOREBOARD_ALL = "SCOREBOARD_MUTATIONS_SET_SCOREBOARD_ALL",
  SCOREBOARD_MUTATIONS_SET_SCOREBOARD_EVT_GRP_SEL = "SCOREBOARD_MUTATIONS_SET_SCOREBOARD_EVT_GRP_SEL",
}

export interface IScoreboardStoreState {
  scoreboardEvent: IScoreboardEvent;
  scoreboardEventsAll: IScoreboardEvent[];
  scoreboardsEventQuery: IScoreboardsEventQuery[];
}

const mutations: MutationTree<IScoreboardStoreState> = {
  [SCOREBOARD_STORE_CONST.SCOREBOARD_MUTATIONS_SET_SCOREBOARD](
    state: IScoreboardStoreState,
    scoreboardEvent: IScoreboardEvent
  ) {
    state.scoreboardEvent = R.clone(scoreboardEvent);
  },
  [SCOREBOARD_STORE_CONST.SCOREBOARD_MUTATIONS_SET_SCOREBOARD_ALL](
    state: IScoreboardStoreState,
    scoreboardEventsAll: IScoreboardEvent[]
  ) {
    state.scoreboardEventsAll = R.clone(scoreboardEventsAll);
  },
  [SCOREBOARD_STORE_CONST.SCOREBOARD_MUTATIONS_SET_SCOREBOARD_EVT_GRP_SEL](
    state: IScoreboardStoreState,
    scoreboardsEventQuery: IScoreboardsEventQuery[]
  ) {
    state.scoreboardsEventQuery = R.clone(scoreboardsEventQuery);
  },
};

const getters = {};

const actions = {};

/**
 * Default state factory for scoreboard store
 * This replaces the inline state definition and ensures pure state initialization
 */
function getDefaultScoreboardState(): IScoreboardStoreState {
  return {
    scoreboardEvent: {} as IScoreboardEvent,
    scoreboardEventsAll: [],
    scoreboardsEventQuery: [],
  };
}

/**
 * Create scoreboard store module with dependency injection
 */
export function createScoreboardStore(
  serviceContainer: any
): Module<IScoreboardStoreState, IRootState> {
  return {
    namespaced: true,
    state: getDefaultScoreboardState(),
    mutations,
    getters,
    actions,
  };
}

// Legacy export for backward compatibility (will be removed after full migration)
export const scoreboardStore: Module<IScoreboardStoreState, IRootState> = {
  namespaced: true,
  state: getDefaultScoreboardState(),
  mutations,
  getters,
  actions,
};
